import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { FileVaultReferenceRelation, GetFileVaultReferenceRelationsRequest, FileVaultCategory, FileVaultSubjectType, SituViewWebApiClient } from 'situview-webapi-client';
import { FileVaultService } from 'src/app/services/file-vault.service';
import { ConfirmDialogComponent } from '../confirm-dialog/confirm-dialog.component';
import { ConfirmDialogService } from 'src/app/services';
import { ConfirmDialogData } from '../confirm-dialog/ConfirmDialogData';
import { MatMenu } from '@angular/material/menu';

@Component({
  selector: 'select-logo-menu',
  templateUrl: './select-logo-menu.component.html',
  styleUrls: ['./select-logo-menu.component.scss']
})
export class SelectLogoMenu implements OnInit, OnChanges {

  @Input() parent!: MatMenu;
  @Input() companyId: string = '';

  @Input() uri?: string;
  @Output() uriChange = new EventEmitter<string>();

  @Input() logoId?: string;
  @Output() logoIdChange = new EventEmitter<string>();

  public logos: FileVaultReferenceRelation[] = [];
  public readonly acceptedTypes = ['.jpg', '.jpeg', '.png'];

  constructor(
    private readonly situViewClient: SituViewWebApiClient,
    private readonly fileVaultService: FileVaultService,
    private readonly confirmDialogService: ConfirmDialogService,
    private readonly snackBar: MatSnackBar,
  ) {
  }

  ngOnInit(): void {
    this.loadLogos();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (this.companyId in changes) {
      this.loadLogos();
    }
  }

  async loadLogos() {
    if (!this.companyId) {
      return;
    }
    let request = new GetFileVaultReferenceRelationsRequest();
    request.category = FileVaultCategory.Logo;
    request.companyId = this.companyId;
    request.subjectId = this.companyId;
    request.includeUri = true;

    let response = await this.situViewClient.getFileVaultReferenceRelations(request);
    if (!response.success) {
      this.snackBar.open("Failed to load marketing files", undefined, { duration: 3000 });
      return;
    }
    this.logos = response.fileVaultReferenceRelations || [];
  }

  public async onFileChosen(files: any) {
    if (this.companyId && files?.length > 0) {
      this.snackBar.open(`Uploading Files...`, 'OK', { duration: 2000 });
      let res = await this.fileVaultService.uploadBlob(this.companyId, this.companyId, FileVaultSubjectType.Company, FileVaultCategory.Logo, files[0]);
      if (res) {
        this.snackBar.open(`${res.fileName} uploaded`, 'OK', { duration: 2000 });
        this.loadLogos();
      }
    }
  }

  public onSelection(ref: FileVaultReferenceRelation | null): void {
    if (ref?.id !== this.logoId || this.uri !== ref?.uri) {
      this.uriChange.emit(ref?.uri);
      this.logoIdChange.emit(ref?.id);
    }
    this.parent.closed.emit("click");
  }

  public async onRemove(file: FileVaultReferenceRelation) {
    this.confirmDialogService.open({
      title: 'Remove File',
      message: `Are you sure you wish to remove '${file.fileName}' permanently?`,
      cancelText: 'No',
      confirmText: 'Yes',
      actionIcon: 'delete',
      actionColour: 'warn'
    } as ConfirmDialogData);

    let confirmed = await this.confirmDialogService.confirmed().toPromise();
    if (confirmed) {
      let removed = await this.fileVaultService.removeFileRequest(file.companyId!, file.subjectId!, file);
      if (removed.success) {
        const index = this.logos.map(x => x.id).indexOf(file.id);
        if (index >= 0) this.logos.splice(index, 1);
      }
    }
  }
}